import React from "react";
import { ActionButtonConfig } from "../types";

interface ProductSummaryHeaderProps {
  actionButtons: ActionButtonConfig[];
  showButtons: boolean;
  onButtonAction: (id: number) => void;
}

/**
 * ProductSummaryHeader Component
 * Single Responsibility: Plain-link action buttons (Mapping/Simulation/History),
 * rendered alongside `ProductSelector` in the page's merged header row.
 */
export const ProductSummaryHeader: React.FC<ProductSummaryHeaderProps> = ({
  actionButtons,
  showButtons,
  onButtonAction
}) => {
  if (!showButtons) return null;

  return (
    <div className="tw-flex tw-items-center tw-gap-5 tw-mt-2">
      {actionButtons.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          type="button"
          onClick={() => onButtonAction(id)}
          className="tw-flex tw-items-center tw-gap-1.5 tw-rounded-lg tw-border tw-border-muted-foreground tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-muted-foreground tw-transition-colors hover:tw-bg-accent hover:tw-text-foreground"
        >
          <Icon className="tw-h-4 tw-w-4" />
          {label}
        </button>
      ))}
    </div>
  );
};
